import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Close from '@mui/icons-material/Close';
import DocumentInviteForm from './DocumentInviteForm';
import { DesignTokenProvider, designToken } from '@proposify/ui';

interface DocumentInviteModalProps {
  isOpen: boolean;
  setIsOpen: (boolean) => void;
  documentName: string;
}

const DocumentInviteModal = ({ isOpen, setIsOpen, documentName }: DocumentInviteModalProps) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <DesignTokenProvider theme={designToken}>
      <Dialog open={isOpen} data-testid="document-invite-modal" disableScrollLock={true} maxWidth="md">
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h6">{t('document_invite.title', { documentName: documentName })}</Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                setIsOpen(false);
              }}
              sx={(theme) => ({
                color: theme.palette.grey[500],
                padding: '5px',
              })}
              data-testid="document-invite-modal-close"
            >
              <Close sx={{ height: '20px', width: '20px' }} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DocumentInviteForm onSuccess={() => setIsOpen(false)} />
        </DialogContent>
      </Dialog>
    </DesignTokenProvider>
  );
};

export default DocumentInviteModal;
